export default "__VITE_ASSET__CxVF2TtS__"